<script>
	import { onMount } from "svelte";
	import { push, pop, replace } from "svelte-spa-router";
	import { shuffle, mean, min } from "lodash";
	import Icon from "svelte-awesome";
	import { faBars } from "@fortawesome/free-solid-svg-icons";
	import Break from "../../components/break/Break.svelte";
	import { onBreak } from "../../components/break/stores";
	import GetRequestApiInstance from "../../services/ServiceRequestApi";
	import GetReactionTimeInstance from "../../services/ServiceReactionTime";
	// instances services
	const requestApiInstance = GetRequestApiInstance();
	const reactionTimeInstance = GetReactionTimeInstance();
	// constantes
	const GAME_NAME = "good-color-name";
	const START_MESSAGE = "Cliquez ici pour commencer !";
	const INITIAL_TIME = 30;
	const ARRAY_COLORS = ["goodColorName-red", "goodColorName-yellow", "goodColorName-green", "goodColorName-blue"];
	const ARRAY_COLORS_NAME = ["Rouge", "Jaune", "Vert", "Bleu"];
	// paramètres
	export let params = {};
	let difficulty = params.difficulty;
	// variables
	let numColor = 0;
	let numColorName = 0;
	let responseButtonsReversed = false;
	let bestScore = 0;
	// result
	let result = {
		game_name: GAME_NAME,
		difficulty: difficulty,
		score: 0,
		average_time_reaction: 0,
		best_time_reaction: 0
	};
	let isStart = false;
	let timer = INITIAL_TIME;
	let timeIsStopped = true;
	let arrayReactionTime = [];
	let arrayResultsHistory = [];
	let interval;
	let textColor;

	$: {
		if(isStart) {
			textColor = `text-${ARRAY_COLORS[numColor]}`;
		} else {
			textColor = 'text-beige-light';
		}
	}

	onMount(() => {
		onBreak.set(false);
		bestScore = getScoreMax();
	});
	
	async function getScoreMax() {
		let responseScoreMax = await requestApiInstance.get(`bestResult/${GAME_NAME}/${difficulty}`);
		return responseScoreMax[0].score;
	}

	function initEnd() {
		isStart = false;
		timeIsStopped = true;
		clearInterval(interval);
		result.score = 0;
		numColor = 0;
		numColorName = 0;
		timer = INITIAL_TIME;
	}

	function initStart() {
		isStart = true;
		timeIsStopped = false;
		randomButtonsResponse();
	}
	
	function handleStart() {
		if (!isStart) {
			initStart();
			reactionTimeInstance.startTimeReaction();
			startTimer();
			randomNum();
		}
	}
	
	function stop() {
		arrayReactionTime = reactionTimeInstance.getArrayReactionTime();
		reactionTimeInstance.resetArrayReactionTime();

		if(arrayReactionTime.length > 0) {
			result.average_time_reaction = Math.round(mean(arrayReactionTime));
			result.best_time_reaction = min(arrayReactionTime);
		}
		
		timeIsStopped = true;
		push("/ranking/" + GAME_NAME + "/" + difficulty + "/" + btoa("game_name=" + result.game_name + "&difficulty=" + result.difficulty + "&score=" + result.score + "&average_time_reaction=" + result.average_time_reaction + "&best_time_reaction=" + result.best_time_reaction ));
	}

	function startTimer() {
		if(!$onBreak && isStart) {
				interval = setInterval(function () {
				if (timer > 0 && !timeIsStopped) {
					timer--;
				} else if(timer == 0) {
					clearInterval(interval);
					stop();
				}
			}, 1000);
		}
	}

	function handleClicBtn(isTrueResult) {
		if (isStart) {
			if ((numColor == numColorName && isTrueResult) || (numColor != numColorName && !isTrueResult)) {
				arrayResultsHistory.push(isTrueResult);
				result.score++;
				if (result.score > bestScore) {
					bestScore = result.score;
				}
				timeToReact();
				randomNum();
				randomButtonsResponse();
			} else {
				stop();
			}
		};
	}

	function randomNum() {
		let randomNum = Math.floor(Math.random() * ARRAY_COLORS.length);
		
		let lengthArrayResultsHistory = arrayResultsHistory.length;		
		if(arrayResultsHistory.length >= 4 && !arrayResultsHistory[lengthArrayResultsHistory - 4] && !arrayResultsHistory[lengthArrayResultsHistory - 3] && !arrayResultsHistory[lengthArrayResultsHistory - 2] && !arrayResultsHistory[lengthArrayResultsHistory - 1]) {
			while (randomNum == numColor || randomNum == numColorName) {
				randomNum = Math.floor(Math.random() * ARRAY_COLORS.length);
			}
			numColor = randomNum;
			numColorName = randomNum;
		} else {
			while (randomNum == numColor) {
				randomNum = Math.floor(Math.random() * ARRAY_COLORS.length);
			}
			numColor = randomNum;
			
			randomNum = Math.floor(Math.random() * ARRAY_COLORS.length);
			while (randomNum == numColorName) {
				randomNum = Math.floor(Math.random() * ARRAY_COLORS.length);
			}
			numColorName = randomNum;
		}
	}

	function randomButtonsResponse() {
		if(difficulty == "hard") {
			if(Math.floor(Math.random() * 2)) {
				responseButtonsReversed = true;
			} else {
				responseButtonsReversed = false;
			}
		}
	}

	function timeToReact() {
		reactionTimeInstance.saveTimeToReact();
	}

	function handleBreakButton() {
		onBreak.set(true);
		timeIsStopped = true;
		initEnd();
	}
</script>

<style>
	.message {
		@apply font-medium text-3xl text-center select-none;
	}
	.button-response {
		@apply outline-none h-1/5 border-none rounded mx-3 my-4 flex justify-center items-center bg-beige-dark text-white text-3xl;
		width: calc(70% / 2);
	}
	.reverse-buttons {
		@apply flex-row-reverse font-light;
	}
</style>

<div class="container-global">
	{#if $onBreak}
		<Break gameName={GAME_NAME} difficulty={difficulty} />
	{/if}
	<div class="h-1/5">
		<div class="header">
			<div class="text-right pt-4 m-auto w-5/6">
				<span class="cursor-pointer" on:click={handleBreakButton}>
					<Icon data={faBars} scale="1.4" />
				</span>
			</div>
			<div class="top-header pb-2">
				<span class="font-semibold text-3xl {timer <= 5 ? 'text-red-500' : ''}">
					{timer}s
				</span>
			</div>
			<div class="middle-header px-4 text-center">
				<div>
					<span class="text-2xl">
						Score : {result.score} | Meilleur score : {#await bestScore}-{:then result}{result}{/await}
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="h-4/5">
		<div
			on:click={handleStart}
			class="w-full relative flex justify-center items-center h-2/5 {textColor} bg-goodColorName-backgroundbeigedark"
		>
			<h2 class="message">{isStart ? ARRAY_COLORS_NAME[numColorName] : START_MESSAGE}</h2>
		</div>
		<div class="w-full h-3/5 bg-beige-light flex justify-center items-center flex-wrap" class:reverse-buttons={responseButtonsReversed}>
			<div on:mousedown={() => handleClicBtn(true)} class="button-response">Vrai</div>
			<div on:mousedown={() => handleClicBtn(false)} class="button-response">Faux</div>
		</div>
	</div>
</div>